export const JOIN_MEETING_EVENTS = {
    JOIN_MEETING: "JOIN_MEETING",
    SEND_DEVICE_INFORMATION: "SEND_DEVICE_INFORMATION",
    RESET_JOIN_MEETING: "RESET_JOIN_MEETING",
};

export const JOIN_MEETING = {
    START: "JOIN_MEETING_START",
    SUCCESS: "JOIN_MEETING_SUCCESS",
    ERROR: "JOIN_MEETING_ERROR",
};

export const SEND_DEVICE_INFORMATION = {
    START: "SEND_DEVICE_INFORMATION_START",
    SUCCESS: "SEND_DEVICE_INFORMATION_SUCCESS",
    ERROR: "SEND_DEVICE_INFORMATION_ERROR",
};

const defaultJoinMeetingState = {
    joinMeetingError: false,
    joinMeetingData: false,
    joinMeetingLoading: false,
};

const defaultSendDeviceInformationState = {
    sendDeviceInformationError: false,
    sendDeviceInformationData: false,
    sendDeviceInformationLoading: false,
};

const defaultCheckDuplicateAgentState = {
    checkDuplicateAgentError: false,
    checkDuplicateAgentData: false,
    checkDuplicateAgentLoading: false,
};

export const defaultState = {
    ...defaultJoinMeetingState,
    ...defaultSendDeviceInformationState,
    ...defaultCheckDuplicateAgentState,
};

const joinMeetingReducer = (state = defaultState, action = {}) => {
    switch (action.event) {
        case JOIN_MEETING_EVENTS.JOIN_MEETING:
            return {
                ...state,
                joinMeetingLoading: action.type === JOIN_MEETING.START,
                joinMeetingData: action.type === JOIN_MEETING.SUCCESS ? action.payload : false,
                joinMeetingError: action.type === JOIN_MEETING.ERROR ? action.payload : false,
            };
        case JOIN_MEETING_EVENTS.SEND_DEVICE_INFORMATION:
            return {
                ...state,
                sendDeviceInformationLoading: action.type === SEND_DEVICE_INFORMATION.START,
                sendDeviceInformationData: action.type === SEND_DEVICE_INFORMATION.SUCCESS ? action.payload : false,
                sendDeviceInformationError: action.type === SEND_DEVICE_INFORMATION.ERROR ? action.payload : false,
            };

        case JOIN_MEETING_EVENTS.RESET_JOIN_MEETING:
            return defaultState;
        default:
            return state;
    }
};

export default joinMeetingReducer;
